import { hot } from 'react-hot-loader/root';
import Component from './accountSettings-redux';

export default hot(Component);
